<template>
	<div class="AppNav">
		<div class="container">
			<div class="row">
				<div class="col-4">
				</div>

				<div class="col-4 text-center">
					<img
						v-if="showLogo && client.style === 'classic'"
						class="AppNav__logo"
						:src="client.logo_image"
						alt="Logo">
				</div>

				<div class="col-4 text-right d-flex justify-content-end align-items-center">
					<button
						v-if="languages.length !== 1"
						class="AppNav__settings AppNav--action"
						:class="{
							'AppNav__settings--dark': client.name === 'Dolci' && client.style === 'classic',
							'AppNav__settings--light': client.name !== 'Dolci' && client.style === 'classic'
						}"
						@click="$router.push({ path: 'languages' })"
					>
						<GlobeIcon />
					</button>

					<button
						v-if="showCategories && client.style === 'modern'"
						class="AppNav__settings AppNav--action"
						@click="$router.push({ path: 'categories-modal' })"
					>
						<SlidersIcon />
					</button>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

const routesWithCategories = [
	'menu',
]

export default {
	components: {
		GlobeIcon: () => import('../assets/images/globe.svg'),
		SlidersIcon: () => import('../assets/images/sliders.svg'),
	},

	computed: {
		...mapGetters({
			categories: 'categories/categories',
			languages: 'languages/languages',
		}),

		showCategories () {
			return routesWithCategories.includes(this.$route.name)
				&& this.categories.length
		},

		showLogo () {
			return routesWithCategories.includes(this.$route.name)
				&& this.client.logo_image
		},
	},
}
</script>

<style lang="scss" scoped>
	.AppNav {
		display: flex;
		justify-content: space-between;
		padding: 16px 0;

		&__search,
		&__settings {
			display: inline-block;
		}

		&__settings {
			margin-left: 20px;

			&--light {
				svg {
					path {
						fill: black;
					}
				}
			}

			&--dark {
				svg {
					path {
						fill: white;
					}
				}
			}
		}

		&--action {
			display: inline-flex;
			border: none;
			background: none;
			padding: 0;
		}

		&__logo {
			max-width: 100px;

			@media (min-width: 768px) {
				max-width: 160px;
			}
		}
	}
</style>
